const baseUrl = process.env.VUE_APP_BASE_API_URL
const backEndUrl = process.env.VUE_APP_FULL_API_URL
const baseUrlAISC = process.env.VUE_APP_BASE_AISC_URL
const baseUrlCountryService = process.env.VUE_APP_BASE_COUNTRY_SERVICE_URL

export default {
  backEnd: {
    token: backEndUrl + '/token/',
    user: backEndUrl + '/user/',
    classTypes: backEndUrl + '/class_types/?format=json',
    airport: backEndUrl + '/airports/?format=json&search=',
    search: backEndUrl + '/search/',
    flightDetails: backEndUrl + '/flight/details/',
    flightFinalDetails: backEndUrl + '/flight/final_details/',
    bookingCreate: backEndUrl + '/booking/create/',
    bookingSendAISC: backEndUrl + '/booking/send_aisc/',
    ferrySendAISC: backEndUrl + '/ferryJson/',
    errorSendAISC: backEndUrl + '/errorJson/'
  },
  sfi: {
    base: baseUrlAISC,
    oauth: baseUrlAISC + '/sfi/oauth/v1',
    issuerIdentifier: baseUrlAISC,
    token: baseUrlAISC + '/token',
    authorize: baseUrlAISC + '/authorize',
    logout: baseUrlAISC + '/logout',
    clientId: 'amplitudes',
    redirectUri: baseUrl + '/code_accept/',
    unauthorizedRedirectUrl () {
      return this.oauth + `/authorize?response_type=code&client_id=${this.clientId}&redirect_uri=${this.redirectUri}&scope=openid profile email address phone od family&state=abcdefgh`
    }
  },
  countryService: {
    base: baseUrlCountryService,
    countriesListWithFlag: baseUrlCountryService + '/all'
  }
}
